import { WeddingApi } from "@wedding/api-client";
const baseUrl =
  import.meta.env.VITE_API_BASE_URL || "http://127.0.0.1:8787/api/v1";
export const api = new WeddingApi(baseUrl);
export type ApiPage<T> = {
  data: T;
  meta: { cursor?: string; generatedAt?: string; requestId?: string };
};

export async function apiFetchPage<T>(
  path: string,
  init?: RequestInit,
): Promise<ApiPage<T>> {
  const response = await fetch(`${baseUrl}${path}`, {
    credentials: "include",
    ...init,
    headers: { "content-type": "application/json", ...init?.headers },
  });
  const body = (await response.json()) as {
    success: boolean;
    data: T;
    error?: { message: string };
    meta?: ApiPage<T>["meta"];
  };
  if (!response.ok || !body.success)
    throw new Error(body.error?.message || "请求失败");
  return { data: body.data, meta: body.meta ?? {} };
}

export async function apiFetch<T>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  return (await apiFetchPage<T>(path, init)).data;
}
